import React, { Component } from 'react';
import { ratingTypes } from '../../../utils/constants';
import { utrTypeIds, ANNUAL_POWER_ONLY_LABEL } from '../../../utils/eventConstants';
import { eventDivisionIsPlatformPaymentOrFree } from '../../../utils/events';

import BallType from '../../text/BallType';

class DivisionCard extends Component {
    constructor(props) {
        super(props);
        this.state = { showPoweredLabel: false };
    }

    render() {
        const {
            name,
            price,
            priceNonPowered,
            gender,
            ageRange,
            utrRange,
            maxPlayers,
            detail,
            additionalDetail,
            registeredCount,
            annualPoweredOnly,
            ballType,
        } = this.props.division;
        const {
            className,
            user,
            eventUtrType,
            registeredPlayersText,
            onClick,
            showFooter,
            workflowVersion,
            showDetails,
            clubVerificationFee,
            showPlayers,
            allowOffPlatformPayments,
            isPaidHitEvent,
            isPaidHitterRegistered,
            'data-testid': dataTestId,
        } = this.props;
        const userIsPowered = user?.isPowered;
        const eventDivisionIsPlatformPaymentOrFreeResult = eventDivisionIsPlatformPaymentOrFree(this.props.division);
        const showPriceNonPowered = (eventDivisionIsPlatformPaymentOrFreeResult && !allowOffPlatformPayments);
        const registeredPlayersCount = isPaidHitEvent && isPaidHitterRegistered ? registeredCount - 1 : registeredCount;
        const isSanctioned = eventUtrType === 'sanctioned' || eventUtrType === utrTypeIds.SANCTIONED;
        return (
            <div
                className={`division-card ${className} ${onClick ? 'clickable' : ''}`}
                onClick={(e) => { if (onClick) { onClick(e); } }}
                onMouseEnter={() => this.setState({ showPoweredLabel: (!userIsPowered && isSanctioned && workflowVersion > 1 && clubVerificationFee > 0 && showPriceNonPowered) })}
                onMouseLeave={() => this.setState({ showPoweredLabel: false })}
            >
                <div className="details row no-gutters">
                    <div className="h6 col-7 text-break" data-testid={dataTestId && `${dataTestId}.name`}>
                        {name}
                    </div>
                    {(isSanctioned && workflowVersion > 1 && clubVerificationFee > 0 && showPriceNonPowered) ? (
                        <div className="col-5 text-right">
                            <div className="h6">
                                <span className={`price price-shifted-right ${(this.state.showPoweredLabel || userIsPowered) ? 'line-through' : ''}`}>{priceNonPowered}</span>
                                <span className={`price-divider`}> / </span>
                                <span className={`price-powered ${(userIsPowered || this.state.showPoweredLabel) ? 'powered-teal' : 'powered-gray'}`}>{price}</span>
                            </div>
                            {(this.state.showPoweredLabel) && <div className={`powered-label-wrapper`}>POWER</div>}
                        </div>
                    ) : (
                        <span className={`col-5 h6 price text-right`} data-testid={dataTestId && `${dataTestId}.price`}>{price}</span>
                    )}
                    <div className={`col-${!eventDivisionIsPlatformPaymentOrFreeResult ? '8' : '12'} description`} data-testid={dataTestId && `${dataTestId}.description`}>
                        {(!!ballType) && <BallType ballType={ballType} />}
                        {annualPoweredOnly && <span className="text-bold text-small">{ANNUAL_POWER_ONLY_LABEL}<br /></span>}
                        {showDetails && (
                            <>
                                {detail}
                                {additionalDetail ? (<span><br />{additionalDetail}</span>) : ''}
                            </>
                        )}
                        {(showPlayers && registeredPlayersText) && registeredPlayersText}
                    </div>
                    {(!eventDivisionIsPlatformPaymentOrFreeResult) && (
                        <div className="col-4 text-right text-teal description">
                            Fee Due in Your Country`s Currency
                        </div>
                    )}
                </div>
                {showFooter && (
                    <div className="footer">
                        <div className="row">
                            {(showPlayers) && (
                                <div className="col-3">
                                    <div className="title">Players</div>
                                    <div className="value">{maxPlayers ? `${registeredPlayersCount}/${maxPlayers}` : registeredPlayersCount}</div>
                                </div>
                            )}
                            <div className="col-3">
                                <div className="title">{ratingTypes.tennis}</div>
                                <div className="value" data-testid={dataTestId && `${dataTestId}.utr-range`}>{utrRange}</div>
                            </div>
                            <div className="col-3">
                                <div className="title">Age</div>
                                <div className="value" data-testid={dataTestId && `${dataTestId}.age-range`}>{ageRange}</div>
                            </div>
                            <div className="col-3">
                                <div className="title">Gender</div>
                                <div className="value" data-testid={dataTestId && `${dataTestId}.gender`}>{gender ? gender.label : '--'}</div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default DivisionCard;
